module.exports = __webpack_public_path__ + "img/san.edd008f7.png";